import type { RoiId } from '~/domain/changes/ids';
/**
 * Where an operation writes its result: a structure it creates, or an
 * existing structure it overwrites. An overwrite starts with `roiId`
 * null, and the operation cannot run until the user picks the structure.
 */
export type OutputTarget =
    | { kind: 'new' }
    | { kind: 'existing'; roiId: RoiId | null };

export const NEW_OUTPUT_TARGET: OutputTarget = { kind: 'new' };

/** The overwrite of structure `roiId`, or of none picked yet. */
export function overwriteTarget(roiId: RoiId | null): OutputTarget {
    return { kind: 'existing', roiId };
}

/** The structure the target overwrites, or null when it overwrites none. */
export function overwrittenRoiId(target: OutputTarget): RoiId | null {
    return target.kind === 'existing' ? target.roiId : null;
}

/** Overwrite is chosen and no structure is picked: nothing to write to. */
export function isOverwriteUnpicked(target: OutputTarget): boolean {
    return target.kind === 'existing' && target.roiId === null;
}
